import { defineComponent as j, ref as v, computed as r, nextTick as z, resolveComponent as h, openBlock as l, createElementBlock as n, normalizeClass as a, Fragment as O, renderList as $, createBlock as C, mergeProps as I, withCtx as i, renderSlot as c, createTextVNode as P, toDisplayString as k, createCommentVNode as d, createVNode as R, withModifiers as A, createElementVNode as D } from "vue";
import { useOverflow as F } from "@onereach/ui-components-common/hooks";
import { O as L } from "./OrButton-C_hXddAf.mjs";
import { O as M } from "./OrPopover-DbygLPtT.mjs";
import "@onereach/ui-components-common/utils";
import { O as q } from "./OrTag-Bixe0EQq.mjs";
import { _ as G } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var p = /* @__PURE__ */ ((o) => (o.Wrap = "wrap", o.Scroll = "scroll", o.Hidden = "hidden", o))(p || {});
const J = [
  // Layout
  "layout-row",
  // Overflow
  "overflow-hidden",
  // Spacing
  "gap-sm",
  // Theme
  "theme-foreground-default",
  "dark:theme-foreground-default-dark"
], K = [
  // Layout
  "layout-row",
  "max-w-full",
  // Spacing
  "gap-sm",
  "py-xs"
], Q = {
  [p.Wrap]: [
    // Layout
    "!flex-wrap"
  ],
  [p.Scroll]: [
    // Layout
    "overflow-y-auto",
    // todo: extract to plugin?
    "[&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']"
  ],
  [p.Hidden]: [
    // Overflow
    "overflow-hidden"
  ]
}, U = [
  // Typography
  "typography-caption-regular"
], X = [
  // Layout
  "layout-row !flex-wrap !content-start overflow-y-auto",
  // Box
  "max-w-[192px] max-h-[340px]",
  // Spacing
  "px-md",
  "py-md",
  "gap-sm"
];
function Y(o) {
  return typeof o == "string" ? {
    label: o,
    value: o
  } : o;
}
const Z = j({
  name: "OrTags",
  components: {
    OrButton: L,
    OrPopover: M,
    OrTag: q
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    overflow: {
      type: String,
      default: () => p.Hidden
    },
    tagProps: {
      type: Object,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "click",
    "focus",
    "blur",
    "reset"
  ],
  expose: [
    "root",
    "container",
    "overflowPopover",
    "scrollToEnd"
  ],
  setup(o) {
    const S = v(), s = v(), m = v(), T = r(() => {
      var t;
      return (t = m.value) == null ? void 0 : t.root;
    }), u = v(), f = r(() => {
      var t;
      return (t = u.value) == null ? void 0 : t.root;
    }), w = r(() => [
      "or-tags-v3",
      ...J
    ]), g = r(() => [
      "or-tags-popover-v3"
    ]), e = r(() => [
      ...K,
      ...Q[o.overflow]
    ]), y = r(() => [
      ...U
    ]), E = r(() => [
      ...X
    ]), { innerItems: N } = F(s, {
      hide: !1,
      threshold: 8
    }), b = r(() => o.items.map(Y)), V = r(() => b.value.slice(N.value.length));
    function H() {
      u.value.toggle();
    }
    function W() {
      z(() => {
        var t, B;
        (B = s.value) == null || B.scrollTo({
          left: (t = s.value) == null ? void 0 : t.scrollWidth,
          behavior: "smooth"
        });
      });
    }
    return {
      root: S,
      container: s,
      localItems: b,
      overflowButton: m,
      overflowButtonRoot: T,
      overflowPopover: u,
      overflowPopoverRoot: f,
      rootStyles: w,
      popoverStyles: g,
      containerStyles: e,
      overflowButtonStyles: y,
      overflowPopoverStyles: E,
      overflowItems: V,
      togglePopover: H,
      scrollToEnd: W
    };
  }
});
function _(o, S, s, m, T, u) {
  const f = h("OrTag"), w = h("OrButton"), g = h("OrPopover");
  return l(), n("div", {
    ref: "root",
    class: a(o.rootStyles)
  }, [
    o.localItems.length > 0 ? (l(), n("div", {
      key: 0,
      ref: "container",
      class: a(o.containerStyles)
    }, [
      (l(!0), n(O, null, $(o.localItems, (e) => (l(), C(f, I({ ...o.tagProps, ...e.tagProps }, {
        key: e.value,
        class: ["max-w-full"],
        onReset: (y) => o.$emit("reset", e.value)
      }), {
        default: i(() => [
          c(o.$slots, "tag", { item: e }, () => [
            P(k(e.label), 1)
          ])
        ]),
        _: 2
      }, 1040, ["onReset"]))), 128)),
      o.overflow === "wrap" ? c(o.$slots, "tail", { key: 0 }) : d("", !0)
    ], 2)) : d("", !0),
    o.overflow === "hidden" && o.overflowItems.length > 0 ? (l(), n(O, { key: 1 }, [
      R(w, {
        ref: "overflowButton",
        class: a(o.overflowButtonStyles),
        type: "button",
        variant: "link",
        color: "inherit",
        disabled: o.disabled,
        onClick: A(o.togglePopover, ["stop"])
      }, {
        default: i(() => [
          P(" +" + k(o.overflowItems.length), 1)
        ]),
        _: 1
      }, 8, ["class", "disabled", "onClick"]),
      R(g, {
        ref: "overflowPopover",
        class: a(o.popoverStyles),
        "custom-styles": o.popoverStyles,
        trigger: o.overflowButtonRoot
      }, {
        default: i(() => [
          D("div", {
            class: a(o.overflowPopoverStyles)
          }, [
            (l(!0), n(O, null, $(o.overflowItems, (e) => (l(), C(f, I({ ...o.tagProps, ...e.tagProps }, {
              key: e.value,
              onReset: (y) => o.$emit("reset", e.value)
            }), {
              default: i(() => [
                c(o.$slots, "tag", { item: e }, () => [
                  P(k(e.label), 1)
                ])
              ]),
              _: 2
            }, 1040, ["onReset"]))), 128))
          ], 2)
        ]),
        _: 3
      }, 8, ["class", "custom-styles", "trigger"])
    ], 64)) : d("", !0),
    o.overflow !== "wrap" || o.items.length === 0 ? c(o.$slots, "tail", { key: 2 }) : d("", !0)
  ], 2);
}
const no = /* @__PURE__ */ G(Z, [["render", _]]);
export {
  no as O,
  p as T
};
//# sourceMappingURL=OrTags-CS0bcLtx.mjs.map
